import React from "react";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { observer } from "mobx-react";
import { Path, UseFormRegister } from "react-hook-form";
import { ContactFormFields } from "src/screens/process/contact/Contact";
import "./OptionalInput.css";

interface OptionalInputProps {
    onBlurInput: any;
    onChangeRadioInput: any;
    radioInputError?: string;
    name: Path<ContactFormFields>;
    register: UseFormRegister<ContactFormFields>;
    errorMessage?: string;
    inputType: "email" | "tel";
    inputLabel: string;
    valueFromBackend?: string;
    valueFromStorage?: string;
    useValueFromBackend?: boolean;
    radioInputPlaceholder: string;
}

const OptionalInputBase = (props: OptionalInputProps) => {
    return props.valueFromBackend ? (
        <>
            <UI.Row>
                <UI.Col>
                    <UI.Form.Group className="mb-0">
                        <UI.Form.Label>{props.inputLabel}</UI.Form.Label>
                    </UI.Form.Group>
                </UI.Col>
            </UI.Row>
            <UI.Row>
                <UI.Col xs={2} className="d-flex align-items-center flex-row radio-col">
                    <input
                        type="radio"
                        id={`${props.name}_radio_predefined`}
                        name={`${props.name}_radio`}
                        value={"true"}
                        onChange={props.onChangeRadioInput}
                        defaultChecked={props.valueFromStorage ? false : props.useValueFromBackend ? true : false}
                        className="contact-radion-button"
                    />
                </UI.Col>
                <UI.Col xs={10} sm={10} className={"radio-element"}>
                    <label htmlFor={`${props.name}_radio_predefined`}>{props.valueFromBackend}</label>
                </UI.Col>
            </UI.Row>
            <UI.Row>
                <UI.Col xs={2} className="d-flex align-items-center flex-row radio-col">
                    <input
                        type="radio"
                        id={`${props.name}_radio_userset`}
                        name={`${props.name}_radio`}
                        value={"false"}
                        onChange={props.onChangeRadioInput}
                        defaultChecked={props.valueFromStorage ? true : props.useValueFromBackend ? false : true}
                        className="contact-radion-button"
                    />
                </UI.Col>
                <UI.Col xs={10} sm={10} className={"radio-element"}>
                    <UI.Input
                        {...props.register(props.name)}
                        errorMsg={props.errorMessage}
                        type={props.inputType}
                        className="mb-0"
                        onBlur={props.onBlurInput}
                        disabled={
                            props.valueFromStorage && !props.useValueFromBackend
                                ? false
                                : props.useValueFromBackend
                                ? true
                                : false
                        }
                        placeholder={props.radioInputPlaceholder}
                    />
                    {props.radioInputError ? (
                        <span className="alert text-danger">{props.radioInputError}</span>
                    ) : undefined}
                </UI.Col>
            </UI.Row>
        </>
    ) : (
        <UI.Row>
            <UI.Col xs={12}>
                <UI.Input
                    {...props.register(props.name)}
                    label={props.inputLabel}
                    errorMsg={props.errorMessage}
                    onBlur={props.onBlurInput}
                    type={props.inputType}
                />
            </UI.Col>
        </UI.Row>
    );
};

export const OptionalInput = Sentry.withProfiler(observer(OptionalInputBase));
